import React from "react"
import ReactDOMServer from "react-dom/server";
import { AiFillCaretDown } from "react-icons/ai";
import COLORS from "scss/colors.module.scss";
import { getTitle } from "../../helpers/getTitle";
import tinycolor from "tinycolor2";


var clickCount = 0;

export default class DropDownColumnRenderer {

  showDownArrow(params) {
    if (params.value !== undefined) {
      return ReactDOMServer.renderToStaticMarkup(<AiFillCaretDown />)
    }
    return ""
  }

  convertStringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  }

  getBackGroundColor(value) {
    if (this.params?.columnRaw?.name != "Operation") {
      return "grey";
    }
    return this.convertStringToColor(value);
  }

  init(params) {
    this.params = params;
    if (params.data?.row_id == "+") {
      this.htmlElement = "";
      return;
    }
    this.clickHandler = function clickHandler() {
      clickCount = clickCount + 1
      if (
        clickCount > 1 &&
        params.store.prevClickedCellRowId ===
          params.api.getFocusedCell().rowIndex &&
        params.store.prevClickedCellColumnId ===
          params.api.getFocusedCell().column.colDef.cellRendererParams.columnId
      ) {
        params.api.startEditingCell({
          colKey: params.colDef.colId,
          rowIndex: params.rowIndex,
        });
        clickCount = 0;
      }
    }

    var columnOptions = params.columnOptions;
    var options = [];
    columnOptions?.options?.map((option, index) => {
      options.push({
        label: typeof option == "string" ? option.trim() : option,
        background: columnOptions.colors?.[index] || "grey",
      });
      return 0;
    });
    const option = options.find((option) => option.label === (typeof params.value == "string" ? params.value?.trim() : params.value));
    if (option && option.background) {
      this.luminance = tinycolor(option.background).getLuminance();
    }

    this.htmlElement = document.createElement('div')
    this.htmlElement.className = "dropDownCell"
    this.htmlElement.title = getTitle(params, params.cellMetaData)
    this.htmlElement.onclick = this.clickHandler
    this.htmlElement.innerHTML = `<div
                                    class="dropDownChip"
                                    style="color:${
                                      this.luminance && this.luminance > 0.5
                                        ? tinycolor(option.background)
                                            .darken(60)
                                            .toString()
                                        : COLORS.PRIMARY_COLOR
                                    }; background-color:${
                                      option
                                        ? option.background
                                        : params.value && params.value != ""
                                        ? ( params.store?.listConfig?.list?.is_log_sheet == 1 ? this.getBackGroundColor(params.value) : "grey" )
                                        : "transparent"
                                    };"
                                  >
                                    ${
                                      option
                                        ? option.label
                                        : params.value && params.value != ""
                                        ? params.value
                                        : ""
                                    }
                                  </div>
                                  <div class="drop_down_arrow" style="margin-top:0px">
                                    ${this.showDownArrow(params)}
                                  </div>`;
  }

  getGui() {
    return this.htmlElement;
  };

  destroy() {
    clickCount = 0
  }
}